import compute from 'components/Compute';

$(() => {
  if ($('#paper_form').length) {
    $('.choice input[type=radio]').on('change', function () {
      console.log('chosen_paper changed');
      window.prices.chosen_paper = $(this).data('paperTitle');
      window.prices.chosen_paper_id = $(this).val();
      compute();
    });

    $('select[name=quantity_papier]').on('change', function () {
      console.log('paper_qty changed');
      const v = $(this).val();
      window.prices.paper_qty = v;
      $('.ci-paper-choice').each(function () {
        const priceTable = $(this).find('.prix').data('prices');
        const quote = priceTable[v];
        const available = !v || !!quote;
        $(this).toggleClass('hidden', !available);
        $(this).find('input[type=radio]').prop('disabled', !available);
        $(this).find('.prix span').text(quote ? quote.prix : '');
      });
      const choices = $('.ci-paper-choice input[type=radio]:enabled');
      if (!choices.filter(':checked').length) { choices.first().prop('checked', true); }
      choices.filter(':checked').trigger('change');
      compute();
      if (v == '') {
        $('.hideIfNoQty').addClass('hidden');
        $('.showIfNoQty').removeClass('hidden');
      } else {
        $('.hideIfNoQty').removeClass('hidden');
        $('.showIfNoQty').addClass('hidden');
      }
    });

    $('select[name=quantity_papier]').trigger('change');

    $('input[name="round_corner"]').on('change', function () {
      window.prices.round_corner = $(this).is(':checked') && $(this).val()==1;
      compute();
    });
  }
});
